import { getCookie } from "cookies-next";

// interfaces
import { IUseQueryResult } from "@/types/api/UseQueryResult";

// helpers
import { useFetch } from "./reactQuery";
import { pathToUrl } from "./reactQuery/pathToUrl";
import API_URLS from "@/api/routes.constant";

// interfaces
import { ICurrency } from "@/types/api/Currency";
import { QueryArgsInterface } from "@/types/api/queryArgs";

const { currenciesUrls } = API_URLS;


const currencies = {
  useCurrenciesList: (args?: QueryArgsInterface) => {
    const { params, config } = args || {};

    return useFetch(currenciesUrls.currencies, params, config) as IUseQueryResult<ICurrency[]>;
  },

  useCurrency: (id: number) => useFetch(id ? pathToUrl(currenciesUrls.currencySingle, { id }) : null) as
  IUseQueryResult<ICurrency>,

  useCurrentCurrency: () => useFetch<string>(API_URLS.currenciesUrls.appCurrentCurrency, {}, {
    queryFn: () => {
      return getCookie("currency") || "GBP";
    },
  }),
};

export default currencies;
